function ChangeVehicleDialogController() {
    // Initialize the controller
    this.constructor.apply(this, arguments);
}


// Dependency injection for the controller
ChangeVehicleDialogController.$inject = ['$scope', '$mdPanel', '$mdDialog', 'VehicleBookingService', '$Loading', '$message', '$translationService', 'options', 'vehicleBooking', 'DeviceService'];


ChangeVehicleDialogController.prototype = {
    /**
     * Initializes the controller with necessary services and scope.
     * @param {angular.IScope} $scope
     * @param {$mdPanel} $mdPanel
     * @param {$mdDialog} $mdDialog
     * @param {VehicleBookingService} VehicleBookingService
     * @param {$Loading} $Loading
     * @param {$message} $message
     * @param {$translationService} $translationService
     * @param {Object} options
     * @param {IVehicleBooking} vehicleBooking
     * @param {DeviceService} DeviceService
     * @constructor

     */
    constructor($scope, $mdPanel, $mdDialog, VehicleBookingService, $Loading, $message, $translationService, options, vehicleBooking, DeviceService) {
        this.$scope = $scope;
        this.$mdPanel = $mdPanel;
        this.$mdDialog = $mdDialog;
        this.vehicleBookingService = VehicleBookingService;
        this.$Loading = $Loading;
        this.$message = $message;
        this.$translationService = $translationService;
        this.options = options;
        this.vehicleBooking = vehicleBooking;
        this.deviceService = DeviceService;



        /** @type {string} */
        this.reason = "";

        /** @type {IVehicle} Don't set vehicle when init  */
        this.vehicle = null;

        this.deviceService.preventBackButton(this.$scope);
    },

    close(data) {
        this.$mdDialog.hide(data);
    },

    /**
     * Make a new charge request
     * @returns {angular.IPromise<void>}
     */
    onCancel() {
        this.close();
    },

    submit() {
        let data = {
            Id: this.vehicleBooking.Id, // vehicleBookingId
            NewVehicleId: this.vehicle.Id,
            Reason: this.reason
        }
        this.vehicleBookingService.changeVehicle(data)
            .then((newVehicleBookingId) => {
                this.close(newVehicleBookingId);
            }, this.$message.error)
            .finally(this.$Loading.blockUI());
    },

    showVehiclePicker($event) {
        let selectedItems = [];
        if (this.vehicle) {
            selectedItems.push(this.vehicle);
        }
        let panelRef;
        let config = {
            controller: VirtualListSelectorController,
            controllerAs: 'vm',
            templateUrl: 'js/shared/virtual-list-selector/virtual-list-selector.view.html',
            targetEvent: $event,
            clickOutsideToClose: false,
            escapeToClose: false,
            hasBackdrop: true,
            panelClass: 'virtual-list-selector-panel',
            zIndex: 90,
            fullscreen: true,
            locals: {
                onClose: (result) => {
                    return panelRef.close(result).finally(() => {
                        if (result) {
                            this.vehicle = result;
                        }
                    })
                },
                loadData: (options) => {
                    return this.vehicleBookingService.getVehiclesFromRange(this.options.availableFrom, this.options.availableTo, options.searchText, options.startIndex, options.count).catch(this.$message.error);
                },
                title: this.$translationService.getTranslation('SelectVehicle'),
                selectedItems: selectedItems,
                options:{
                    itemSize: 75,
                    templateItem: 'vehicle-item-template',
                    lazyLoad: true
                }
            }
        };
        panelRef = this.$mdPanel.create(config);
        this.panelRef= panelRef;
        this.panelRef.open().then((panel) => {
            panel._config.scope.vm.ready();
        });
    }
};


// Register  controller with the AngularJS module
angular.module('internal.vehiclebookings').controller('ChangeVehicleDialogController', ChangeVehicleDialogController);